<template>
  <update-business-member-field
    title="Legal First and Last Name"
    :value="member.fullName"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-text-field placeholder="Enter legal first and last name" v-model="fullName" required />
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fullName: "",
    };
  },
  methods: {
    handleIsEditing($event) {
      this.fullName = this.member.fullName;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        fullName: this.fullName,
      });
    },
  },
};
</script>
